import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { trigger, transition, style, animate } from '@angular/animations';
import { Component, ElementRef, HostListener, Input, Renderer2, viewChild } from '@angular/core';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { environment } from '../../../../environments/environment.prod';
import { NgStyle, NgClass } from '@angular/common';
import { ContentAnimDirective } from '../../product-layout/content-anim.directive';


@Component({
  selector: 'calsoft-animated-scroll-review',
  imports: [CustomFlexLayoutModule,NgStyle,NgClass,ContentAnimDirective],
  templateUrl: './animated-scroll-review.component.html',
  styleUrl: './animated-scroll-review.component.scss'
})
export class AnimatedScrollReviewComponent {

  readonly reviewsContainer = viewChild.required<ElementRef>('reviewsContainer');
    @Input() data : any;
    @Input() item : any;
    @Input() images : any;
  loaderHeight: number = 0; 
  totalItems: number = 0; 
  viewedItems: number = 0; 
    public serverPath1 = environment.commonImageApi + '/home/';
    isMobile = false;
    
  ngOnInit(): void {
    console.log("ngOnInit called");
    this.updateColorsBasedOnData();
    this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall]).subscribe(result => {
      this.isMobile = result.matches;
     
    });
  }



  changeTheme(bgColor: string, textColor: string, textColorTwo: string) {
    console.log("Applying Colors:", bgColor, textColor, textColorTwo);
  
    const commonVarElement = this.el.nativeElement.querySelector('.common-var');
    
    if (commonVarElement) {
      commonVarElement.style.setProperty('--bg-color', bgColor);
      commonVarElement.style.setProperty('--text-color', textColor);
      commonVarElement.style.setProperty('--texttwo-color', textColorTwo);
    } else {
      console.error("Element with class .common-var not found!");
    }
  }
  

  updateColorsBasedOnData() {
    if (this.item != null) {
      this.changeTheme(this.item.customField25, this.item.customField29, this.item.customField30);
    } else {
      console.error("Item is null, cannot update colors.");
    }
  }
  constructor(private renderer: Renderer2,private el: ElementRef,private breakpointObserver: BreakpointObserver) {}

  ngAfterViewInit() {
    console.log("ngAfterViewInit called");
    this.updateColorsBasedOnData();  
    const options = {
      root: null, 
      rootMargin: '0px',
      threshold: 0.2 
    };
    setTimeout(() => {
      this.totalItems = document.querySelectorAll('.review-item').length;
    }, 500);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.renderer.addClass(entry.target, 'animate-review'); // Add animation class
        } else {
          this.renderer.removeClass(entry.target, 'animate-review'); // Remove class if needed
        }
      });
    }, options);

    const reviewItems = this.reviewsContainer().nativeElement.querySelectorAll('.review-item');
    reviewItems.forEach((item: Element) => observer.observe(item));
  }
  @HostListener('window:scroll', [])
  onScroll() {
    let viewed = 0;
    const reviewItems = document.querySelectorAll('.review-item');

    reviewItems.forEach((item) => {
      if (this.isElementInView(item as HTMLElement)) {
        viewed++;
      }
    });

    this.viewedItems = viewed;
    this.updateLoader();
  }

  isElementInView(el: HTMLElement): boolean {
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < windowHeight && rect.bottom > 0; // If any part is visible
  }

  updateLoader() {
    this.loaderHeight = (this.viewedItems / this.totalItems) * 100;
    const loaderLine = this.el.nativeElement.querySelector('.loader-line') as HTMLElement;
    if (loaderLine) {
      loaderLine.style.height = `${this.loaderHeight}%`;
    }
  }
}
